module.exports = __webpack_public_path__ + "img/10.c770ad4f.gif";